unit AgentRegisterClient;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  RegisterForm,
  XData.Web.Connection,
  XData.Web.Client,
  WEBLib.StdCtrls,
  WEBLib.Country,
  Vcl.Controls,
  WEBLib.WebCtrls,
  Vcl.StdCtrls,
  WEBLib.ExtCtrls,
  GA.Registration.Classes;

type
  TAgentClientForm = class(TRegisterWebForm)
    CancelButton: TButton;
    procedure CancelButtonClick(Sender: TObject);
  private
    FAgentId: Integer;
    { Private declarations }
  protected
    function LoadUser: TRegisterUser; override;
    function LoadOrganisation: TRegisterOrganisation; override;
    [async]
    procedure LoadThankYou; async; override;
  public
    { Public declarations }
    property AgentId: Integer read FAgentId write FAgentId;
  protected procedure LoadDFMValues; override; end;

var
  AgentClientForm: TAgentClientForm;

implementation

{$R *.dfm}

procedure TAgentClientForm.CancelButtonClick(Sender: TObject);
begin
  ModalResult := mrCancel;
end;

{ TAgentClientForm }

function TAgentClientForm.LoadOrganisation: TRegisterOrganisation;
begin
  Result := inherited LoadOrganisation;
  Result.AgentId := FAgentId;
  Result.OrganisationKind := 'ManagedTenant';
end;

procedure TAgentClientForm.LoadThankYou; {$IFDEF PAS2JS}async;{$ENDIF}
begin
  //inherited;
  ModalResult := mrOK;
end;

function TAgentClientForm.LoadUser: TRegisterUser;
begin
  Result := inherited LoadUser;
  Result.InternalId := 0;
end;

procedure TAgentClientForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  CancelButton := TButton.Create('CancelButton');

  CancelButton.BeforeLoadDFMValues;
  OrganisationTypeCombo.BeforeLoadDFMValues;
  try
    CancelButton.SetParentComponent(Self);
    CancelButton.Name := 'CancelButton';
    CancelButton.Left := 392;
    CancelButton.Top := 255;
    CancelButton.Width := 96;
    CancelButton.Height := 25;
    CancelButton.Caption := 'Cancel';
    CancelButton.ChildOrder := 12;
    CancelButton.ElementClassName := 'btn btn-light';
    CancelButton.ElementFont := efCSS;
    CancelButton.ElementPosition := epIgnore;
    CancelButton.HeightStyle := ssAuto;
    CancelButton.HeightPercent := 100.000000000000000000;
    CancelButton.WidthStyle := ssAuto;
    CancelButton.WidthPercent := 100.000000000000000000;
    SetEvent(CancelButton, Self, 'OnClick', 'CancelButtonClick');
    OrganisationTypeCombo.Visible := False;
  finally
    CancelButton.AfterLoadDFMValues;
    OrganisationTypeCombo.AfterLoadDFMValues;
  end;
end;

end.
